export const API_SERVERLESS_ENDPOINT = process.env.REACT_APP_API_SERVERLESS_ENDPOINT;
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const APP_NAME = process.env.REACT_APP_NAME;

export const AWS_ASSET_URL = process.env.REACT_APP_AWS_ASSET_URL;
export const AWS_OUTPUT_URL = process.env.REACT_APP_AWS_OUTPUT_URL;
export const CDN_URL = process.env.REACT_APP_CDN;
export const CDN_VIDEO_URL = process.env.REACT_APP_CDN_VIDEO_URL;
export const BUCKET_URL = process.env.REACT_APP_BUCKET_URL;
export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const APP_AUTH_TOKEN_NAME = 'id_token';
//BUCKET
export const AV_ENV = process.env.REACT_APP_NODE_ENV_TYPE;
const IS_PRODUCTION = AV_ENV === 'prod' ? true : false;
export const APP_DOMAIN = IS_PRODUCTION ? 'https://www.airvuz.com' : 'https://beta.airvuz.com';

export const INPUT = IS_PRODUCTION ? 'airvuz-drone-video-input' : 'airvuz-videos-beta-input';
export const OUTPUT = IS_PRODUCTION ? 'airvuz-drone-video' : 'airvuz-videos-beta';
export const ASSET = IS_PRODUCTION ? 'airvuz-asset' : 'airvuz-asset-beta';
export const PHOTO = IS_PRODUCTION ? 'airvuz-drone-photo' : 'airvuz-drone-photo-beta';
export const CDN_PHOTO = 'drone-photo';
export const TEMP = 'airvuz-tmp';
export const UGCS = 'airvuz-ugcs-input';
export const UGCS_TEMP = 'airvuz-ugcs-temp';

//URL
export const PHOTO_URL = IS_PRODUCTION ? CDN_URL + '/' + PHOTO + '/' : BUCKET_URL + PHOTO + '/';

//OTHER
export const PIPELINE_ID = IS_PRODUCTION ? '1455744809087-s0jcq3' : '1452901546045-62g3bq';
export const AMAZON_UPLOAD_TEMP = IS_PRODUCTION ? 'airvuz-drone-video-temp' : 'airvuz-beta-temp';
export const OUTPUT_URL = BUCKET_URL + OUTPUT + '/';
export const INPUT_URL = BUCKET_URL + INPUT + '/';
export const ASSET_URL = BUCKET_URL + ASSET + '/';
export const TEMP_URL = BUCKET_URL + TEMP + '/';
export const OUTPUT_PHOTO_URL = BUCKET_URL + PHOTO + '/';
export const UGCS_URL = BUCKET_URL + UGCS + '/';
export const UGCS_TEMP_URL = BUCKET_URL + UGCS_TEMP + '/';
export const AMAZON_UPLOAD_TEMP_URL = BUCKET_URL + AMAZON_UPLOAD_TEMP + '/';

//CDN
export const CDN_PHOTO_URL = CDN_URL + '/' + CDN_PHOTO;

export let ACCESS_KEY = process.env.REACT_APP_AWS_ACCESS_KEY;
